import axios from 'axios';
import _find from 'lodash/find';
import Vue from 'vue';
import { request_mutations, request_state } from '../utils/store';
import { find_by_id, remove_by_id } from '../utils/data';
import { auth } from '../utils/requests';
import {
    TOPICS_DETAIL, TOPICS_BOOKMARK, TOPICS_LIST, TOPICS_GENERAL,
} from '../api';

export default {
    namespaced: true,
    state: {
        list: request_state(),
        detail: request_state(),
        search: request_state(),
        create: request_state(),
        remove: request_state(),
        update: request_state(),
        bookmark: request_state(),
        make_general: request_state(),
    },
    mutations: {
        ...request_mutations('topics_list', 'list'),
        ...request_mutations('topics_detail', 'detail'),
        ...request_mutations('create_topic', 'create'),
        ...request_mutations('remove_topic', 'remove'),
        ...request_mutations('update_topic', 'update'),
        ...request_mutations('search_topic', 'search'),
        ...request_mutations('bookmark_topic', 'bookmark'),
        ...request_mutations('make_general', 'make_general'),

        add_topic(state, { topic, parent_id }) {
            const { data } = state.list;
            const list = parent_id ? find_by_id(data, parent_id).children : data;
            Vue.set(topic, 'bookmarked', topic.bookmarked || false);
            list.unshift(topic);
        },
        toggle_private(state, { id, value }) {
            const topic = _find(state.list.data, { id });
            Vue.set(topic, 'is_private', value);
        },
        remove_topic(state, { topic_id, parent_id }) {
            if (parent_id) {
                const parent = find_by_id(state.list.data, parent_id);
                parent.children = remove_by_id(parent.children, topic_id);
                return;
            }
            state.list.data = remove_by_id(state.list.data, topic_id);
        },
        update_topic(state, { topic_id, parent_id, name }) {
            const { data } = state.list;
            const list = parent_id ? find_by_id(data, parent_id).children : data;
            const topic = find_by_id(list, topic_id);
            topic.name = name;
        },
        make_general(state, topic_id) {
            state.list.data = state.list.data.map((item) => {
                item.is_general = item.id === topic_id;
                return item;
            });
        },
    },
    actions: {
        list({ commit }, { space_id }) {
            commit('topics_list_loading');
            return new Promise((resolve) => {
                axios.get(TOPICS_LIST.replace('{space_id}', space_id), auth()).then((response) => {
                    commit('topics_list_success', response.data);
                    resolve();
                }).catch((error) => {
                    commit('topics_list_error', error.response ? error.response.data : {});
                });
            });
        },
        detail({ commit }, { space_id, topic_id }) {
            const url = TOPICS_DETAIL.replace('{space_id}', space_id).replace('{topic_id}', topic_id);

            commit('topics_detail_loading');
            return new Promise((resolve) => {
                axios.get(url, auth()).then((response) => {
                    commit('topics_detail_success', response.data);
                    resolve(response.data);
                }).catch((error) => {
                    commit('topics_detail_error', error.response ? error.response.data : {});
                });
            });
        },
        create({ commit }, { space_id, parent_id, data }) {
            const url = TOPICS_LIST.replace('{space_id}', space_id);

            commit('create_topic_loading');
            return new Promise((resolve) => {
                data.parent = parent_id;
                axios.post(url, data, auth()).then((response) => {
                    commit('create_topic_success', response.data);
                    resolve(response.data);
                }).catch((error) => {
                    commit('create_topic_error', error.response ? error.response.data : {});
                });
            });
        },
        update({ commit }, {
            space_id, parent_id, topic_id, data,
        }) {
            const url = TOPICS_DETAIL.replace('{space_id}', space_id).replace('{topic_id}', topic_id);

            commit('update_topic_loading');
            return new Promise((resolve) => {
                axios.patch(url, data, auth()).then((response) => {
                    commit('update_topic_success', response.data);
                    commit('update_topic', { topic_id, parent_id, name: response.data.name });
                    resolve();
                }).catch((error) => {
                    commit('update_topic_error', error.response ? error.response.data : {});
                });
            });
        },
        bookmark({ commit }, { space_id, topic_id, remove }) {
            const url = TOPICS_BOOKMARK.replace('{space_id}', space_id).replace('{topic_id}', topic_id);

            commit('bookmark_topic_loading');
            return new Promise((resolve) => {
                const request = remove ? axios.delete(url, auth()) : axios.post(url, {}, auth());

                request.then((response) => {
                    commit('bookmark_topic_success', response.data);
                    resolve(response.data);
                }).catch((error) => {
                    commit('bookmark_topic_error', error.response ? error.response.data : {});
                });
            });
        },
        remove({ commit }, { space_id, parent_id, topic_id }) {
            const url = TOPICS_DETAIL.replace('{space_id}', space_id).replace('{topic_id}', topic_id);

            commit('remove_topic_loading');
            axios.delete(url, auth()).then((response) => {
                commit('remove_topic_success', response.data);
                commit('remove_topic', { topic_id, parent_id });
            }).catch((error) => {
                commit('remove_topic_error', error.response ? error.response.data : {});
            });
        },
        make_general({ commit }, { space_id, topic_id }) {
            const url = TOPICS_GENERAL.replace('{space_id}', space_id).replace('{topic_id}', topic_id);

            commit('make_general_loading');
            axios.put(url, {}, auth()).then((response) => {
                commit('make_general_success', response.data);
            }).catch((error) => {
                commit('make_general_error', error.response ? error.response.data : {});
            });
        },
    },
    getters: {
        by_id: state => (id) => {
            if (Array.isArray(state.list.data) && id) {
                return find_by_id(state.list.data, parseInt(id, 10));
            }

            return null;
        },
        general_topic_id(state) {
            if (Array.isArray(state.list.data)) {
                const topic = _find(state.list.data, { is_general: true });
                return topic ? topic.id : null;
            }

            return null;
        },
    },
};
